import { Component, Input } from '@angular/core';

export enum AlertTypeBase {
  Info = 'info',
  Warning = 'warning',
  Danger = 'danger',
  Success = 'success',
  Message = 'message'
}

export type AlertType = AlertTypeBase | 'info' | 'warning' | 'danger' | 'success';

@Component({
    selector: 'lib-alert-message',
    templateUrl: './alert-message.component.html',
    styleUrls: ['./alert-message.component.scss'],
    standalone: false
})
export class AlertMessageComponent {
  @Input() type: AlertType = AlertTypeBase.Info;
}
